import React from 'react';
import PropTypes from 'prop-types';
import {createFragmentContainer, graphql} from 'react-relay';
import CategoryItem1List from './CategoryItem1List';
import {Message} from '@aperza/ui';

class CategoryMenu extends React.Component {

  static propTypes = {
    onClose: PropTypes.func,
    disableMarketplaceBanner: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      showCategoryList: false,
    }
  }

  onMouseOverCategory() {
    this.setState({
      showCategoryList: true,
    })
  }

  onMouseLeaveCategory(e) {
    let rect = this.categoryMenu.getBoundingClientRect();
    if (e.clientY < rect.bottom) {
      this.setState({
        showCategoryList: false,
      })
    }
  }

  onCloseCategory() {
    this.setState({
      showCategoryList: false,
    })
  }

  render() {

    let {
      productCategories
    } = this.props;

    let {
      showCategoryList
    } = this.state;

    return (
      <div id="categoryMenu"
           ref={categoryMenu => {
             this.categoryMenu = categoryMenu;
           }}
           onMouseOver={::this.onMouseOverCategory} onMouseLeave={::this.onMouseLeaveCategory}>
        <a className="categoryDrawer" >
          <Message messageId="navbar.category" /><i className="fa fa-caret-down" aria-hidden="true"></i>
        </a>
        {productCategories && <CategoryItem1List show={showCategoryList} productCategories={productCategories} onClose={::this.onCloseCategory} {...this.props} />}
      </div>
    )
  }

}

export default createFragmentContainer(CategoryMenu, {
  productCategories: graphql`
      fragment CategoryMenu_productCategories on ProductCategory @relay(plural: true) {
          displayCategoryId
          level
          name
          itemCount
          children {
              displayCategoryId
              level
              name
              itemCount
          }
      }
  `,

});
